
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/9752b57f5bb5ebb0a6e83337e3713255.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="w-full">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Discover South Africa's
            <span className="block text-emerald-400">Finest Private Chefs</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            From traditional braai masters to fine dining specialists, connect with exceptional culinary talent 
            for your next intimate dinner, special celebration, or corporate event.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/chefs">
              <Button size="lg" className="w-full sm:w-auto">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-search-line"></i>
                </div>
                Find Your Chef
              </Button>
            </Link>
            <Link to="/about">
              <Button variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 border-white text-white hover:bg-white hover:text-gray-900">
                Learn More
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
